module.exports = __webpack_public_path__ + "static/media/trainPathFileImportTemp.4a5a2e2d.xlsx";